import get from 'lodash/get'
import has from 'lodash/has'
import unset from 'lodash/unset'

import MigrationShouldRun from 'api/migrate/MigrationShouldRun'
import UpdateVersion from 'api/migrate/UpdateVersion'

/**
 * Run the migration if version is less than the config.
 *
 * @param {Object} config
 */
export default function (config) {
  const MIGRATION_TO_VERSION = 1

  if (MigrationShouldRun(config, MIGRATION_TO_VERSION)) {
    // Run migration scripts here...
    if (has(config, 'layout.drawer.tabs.tools.login.amplify')) {
      if (get(config, 'layout.drawer.tabs.tools.login.amplify.Auth.identityPoolId', '') === '') {
        unset(config, 'layout.drawer.tabs.tools.login.amplify')
      }
    }
    UpdateVersion(config, MIGRATION_TO_VERSION)
  }

  return config
}
